import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import { OMS_LOOKUP_SUCCESS } from '@src/app/login/oms/actions';
import {
  CustomCustomer,
  Permissions,
} from 'gc-backend';
import {
  EMAIL_SAVE_SUCCESS,
  ACCOUNT_SAVE_SUCCESS,
} from '@src/app/accounts/summary';
import { UpdateEmailResponse } from '@src/app/_global/domain';
import { UpdateAccountResponse } from '@src/app/_global/domain/UpdateAccountResponse';
import { SAVE_PREFERENCES_SUCCESS } from '@src/app/accounts/preferences/actions';
import { nameAddressPayload } from '@src/test/login/weak/nameaddress/testPayload';

export type State = {
  customers: Array<CustomCustomer> | null;
};

export const reducer = combineReducers<State, RootAction>({
  customers: (state = null, action) => {
    switch (action.type) {
      case OMS_LOOKUP_SUCCESS:
        return action.payload.customers;
      case EMAIL_SAVE_SUCCESS:
        let customers;
        const response: UpdateEmailResponse = action.payload;
        const newEmail = response.email;
        if (state) {
          customers = state.map(cust => {
            cust.email = newEmail;
            return cust;
          });
        }
        return customers;
      case ACCOUNT_SAVE_SUCCESS:
        return state;
      case SAVE_PREFERENCES_SUCCESS:
        let permissionSaveCustomer;
        let permissionSaveCustomers;
        let permissionUpdateResponse = action.payload.response;
        if (state) {
          permissionSaveCustomers = state;
          permissionSaveCustomer = permissionSaveCustomers.find(cust => {
            return (
              permissionUpdateResponse.accountNumber === cust.accountNumber &&
              permissionUpdateResponse.prodIdAlias === cust.prodIdAlias
            );
          });
          for (let key in permissionUpdateResponse) {
            if (key) {
              let value = permissionUpdateResponse[key];
              if (
                key !== 'accountNumber' &&
                key !== 'prodIdAlias' &&
                key !== 'email'
              ) {
                permissionSaveCustomer.permissions[key] = value ? 'Y' : 'N'; // map back to boolean for state
              }
            }
          }
        }
        return permissionSaveCustomers;
      default:
        return state;
    }
  },
});
